document.addEventListener('DOMContentLoaded', () => {
    // Timeline swiper (special layout and controls)
    const timelineSwiperElement = document.querySelector('.timelineSwiper');
    if (timelineSwiperElement && typeof Swiper !== 'undefined') {
        new Swiper(timelineSwiperElement, {
            loop: false,
            speed: 800,
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.logo-carousel-next',
                prevEl: '.logo-carousel-prev',
            },
            breakpoints: {
                640: { slidesPerView: 1, spaceBetween: 0 },
                768: { slidesPerView: 2, spaceBetween: 0 },
                1024: { slidesPerView: 3, spaceBetween: 0 },
            },
        });
    }

    // Generic carousels
    document.querySelectorAll('.swiper').forEach(container => {
        if (typeof Swiper === 'undefined') return;
        const slides = container.querySelectorAll('.swiper-slide');

        // Find a pagination element only inside the swiper or a named wrapper
        const fromClosest = container.closest('.swiperContainer');
        const paginationEl = container.querySelector('.swiper-pagination')
            || (fromClosest && fromClosest.querySelector('.swiper-pagination'))
            || null;

        const config = {
            speed: 400,
            spaceBetween: 16,
            loop: slides.length > 3,
            breakpoints: {
                320: { slidesPerView: 1.5, spaceBetween: 16 },
                640: { slidesPerView: 1.5, spaceBetween: 16 },
                768: { slidesPerView: 2.5, spaceBetween: 16 },
                1024: { slidesPerView: 3, spaceBetween: 16 },
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            }
        };

        if (paginationEl) {
            config.pagination = { el: paginationEl, clickable: true, dynamicBullets: true };
        }

        new Swiper(container, config);
    });
});
